import { useRef, useState } from 'react';
import Props from './types';
import S from './LabelStyles';
import HoverCaption from '../../HoverCaption/HoverCaption';

function Label({ label, onClick, caption }: Props):JSX.Element {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [captionVisible, setCaptionVisible] = useState(false);

  return (
    <S.Wrapper
      ref={wrapperRef}
      onClick={onClick}
      onMouseEnter={caption ? () => setCaptionVisible(true) : undefined}
      onMouseLeave={caption ? () => setCaptionVisible(false) : undefined}
    >
      <p> { label } </p>
      {!!caption && captionVisible && (
        <HoverCaption anchorRef={wrapperRef}>{caption}</HoverCaption>
      )}
    </S.Wrapper>
  );
}

export default Label;
